export default "__VITE_ASSET__DO_6FPd0__"